<template>
  <SweetModal ref="modal"
              :title="confirm.title"
              :blocking="true"
              overlay-theme="dark"
              :hide-close-button="true"
  >
    <p v-html="confirm.message"></p>

    <div v-if="requiredTerm"
              class="my-2">
      <p class="mb-2">Please enter "{{ requiredTerm }}" into the box as shown to confirm your intent.</p>

      <input class="form-control" style="width: 200px;" ref="termInput" v-model="termInput" autofocus
        @keypress.enter="$refs.acceptButton.click()">
    </div>

    <template slot="button">
      <button
        v-if="!confirm.hideCancel"
        class="btn"
        :class="confirm.cancelClass"
        @click="close(false)"
      >
        {{ confirm.cancelText }}
      </button>
      <button class="btn"
        ref="acceptButton"
        :class="confirm.acceptClass"
        :disabled="termInput !== requiredTerm"
        @click="close(true)">
        {{ confirm.acceptText }}
      </button>
      <button
        v-if="confirm.actionFunc"
        class="btn"
        ref="saveButton"
        :class="confirm.actionClass"
        @click="close(confirm.actionFunc)">
        {{ confirm.actionText }}
      </button>
    </template>
  </SweetModal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ConfirmDialog',
  components: { SweetModal },
  data () {
    return {
      randomPIN: 0,
      termInput: ''
    }
  },
  computed: {
    ...mapState('dialogs', ['confirm', 'isConfirmOpen']),
    requiredTerm () {
      if (!this.confirm.confirmTerm && !this.confirm.confirmLevel) {
        return ''
      }
      let term = this.confirm.confirmTerm || ''
      if (this.confirm.confirmLevel) {
        term += (term ? '-' : '') + this.randomPIN
      }
      return term
    }
  },
  watch: {
    isConfirmOpen (open) {
      if (open) {
        this.randomPIN = Math.floor(Math.random() * 9000) + 1000
        this.termInput = ''
        this.$refs.modal.open()
        setTimeout(() => {
          if (this.$refs.termInput) {
            this.$refs.termInput.focus()
          }
        }, 50)
      }
    }
  },
  methods: {
    ...mapMutations('dialogs', ['CLOSE_CONFIRM']),
    close (result) {
      const unwatch = this.$watch('$refs.modal.is_open', async isOpen => {
        if (!isOpen) {
          if (typeof result === 'function') {
            await result()
          }
          unwatch()
          this.confirm.resolve(result)
          this.CLOSE_CONFIRM()
        }
      })

      this.$refs.modal.close()
    }
  }
}
</script>
